import { SavedSearch } from '@creditsights/api-ui-web';
import {
  DATE_RELATIVE_RANGE_URL_KEY,
  END_DATE_URL_KEY,
  START_DATE_URL_KEY,
} from '../../components/FiltersBar/FiltersBar.logic';
import { DATE_FORMATS, formatDate } from '../../utils/dateUtils';
import { SEARCH_TERM_URL_KEY } from './SearchResults.constants';

export const getUrlSearchParams = (search: SavedSearch): URLSearchParams => {
  const searchParams = new URLSearchParams();

  search.filters.forEach((filter) => {
    filter.tags.forEach((tag) => {
      searchParams.append(filter.filterType, tag.tagId);
    });
  });

  if (search.dateRange?.relativeRange) {
    searchParams.set(DATE_RELATIVE_RANGE_URL_KEY, search.dateRange.relativeRange);
  } else {
    if (search.dateRange?.startDate) {
      searchParams.set(
        START_DATE_URL_KEY,
        formatDate(new Date(search.dateRange.startDate), DATE_FORMATS.YEAR_MONTH_DAY)
      );
    }

    if (search.dateRange?.endDate) {
      searchParams.set(END_DATE_URL_KEY, formatDate(new Date(search.dateRange.endDate), DATE_FORMATS.YEAR_MONTH_DAY));
    }
  }

  searchParams.set(SEARCH_TERM_URL_KEY, search.keywords!);

  if (search.sort) {
    searchParams.set('sort', search.sort);
  }

  if (search.tab) {
    searchParams.set('category', search.tab);
  }

  return searchParams;
};
